import React, { Component } from 'react';
import SwalServices from '../../services/swalServices/SwalServices';
import ValidationText from '../../utils/validation/ValidationText';
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { CommonValidationMessages } from '../../utils/Messages';
import DropdownSelect from '../../components/dropdown/Dropdown';
import DatePicker from '../../components/datePicker/DatePicker';
import TimePicker from '../../components/TimePicker.js/TimePicker';
import CKClassicEditor from '../../components/ckEditor/CKClassicEditor';
import InputText from '../../components/inputs/InputText';
import moment from 'moment';
import { axiosGetAuthorize, axiosPostAuthorize } from '../../services/axiosServices/AxiosRequests';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import eVotingServices from '../../services/axiosServices/apiServices/eVotingServices';

export default class General extends Component {
  constructor(props) {
    super(props);
    this.swalServices = new SwalServices();
    this.eVotingServices = new eVotingServices();

    this.state = {
      adminUserId: 0,
      generalSettings: {
        positionsCount: 0,
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
        instructionDescription: "",
        importantNotes: "",
        agmUrl: "",
      },
      validationRules: {
        positionsCount: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'positions count'),
          }
        ],
        startDate: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'Start Date'),
          }
        ],
        startTime: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'Start Time'),
          }
        ],
        endDate: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'End Date'),
          }
        ],
        endTime: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'End Time'),
          }
        ],
        instructionDescription: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'Instruction Description'),
          }
        ],
        agmUrl: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'AGM URL'),
          }
        ]
      },
      validState: {
        isValid: true,
        error: {}
      },
      positionsOptions: Array.from({ length: 20 }, (_, i) => ({ id: i + 1, name: String(i + 1) }))
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    let detail = { ...this.state.generalSettings };
    detail[name] = value;
    this.setState({ generalSettings: detail }, () => {
      this.validateField(name);
    });
  };

  handleDropdownChange = (value, name) => {
    let detail = { ...this.state.generalSettings };
    detail[name] = value;
    this.setState({ generalSettings: detail }, () => {
      this.validateField(name);
    });
  };

  handleTimeChange = (timeObj) => {
    let detail = { ...this.state.generalSettings };
    detail[timeObj.identity] = timeObj.selectedTime;
    this.setState({ generalSettings: detail }, () => {
      this.validateField(timeObj.identity);
    });
  };

  handleEditorChange = (data, name) => {
    let detail = { ...this.state.generalSettings };
    detail[name] = data;
    this.setState({ generalSettings: detail }, () => {
      // Only validate if a validation rule exists for this field (importantNotes has no validation)
      if (this.state.validationRules && Object.prototype.hasOwnProperty.call(this.state.validationRules, name)) {
        this.validateField(name);
      }
    });
  };

  validateField = (key) => {
    const newValidState = validate(
      key,
      this.state.generalSettings,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };

  isValidateAllFields = () => {
    const newValidState = isValidForm(
      this.state.generalSettings,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  componentDidMount() {
    // Load existing basic setting for the logged in admin
    let cookie = getAuthProps();
    const adminUserId = cookie?.adminUserId ? Number(cookie.adminUserId) : 0;

    this.setState({ adminUserId: adminUserId }, () => {
      this.geteVotingBasicSetting(adminUserId);
    });
  }

  geteVotingBasicSetting = (adminUserId) => {
    if (adminUserId > 0) {
      this.eVotingServices.geteVotingBasicSettingByAdminId(adminUserId)
        .then((response) => {
          if (response && response.statusCode === 200 && response.responseItem != null && response.responseItem.responseContent != null) {
            debugger
            const data = response.responseItem.responseContent;
            if (data) {
              let gs = { ...this.state.generalSettings };
              debugger
              // Map backend DTO to component state (try multiple casings to be safe)
              gs.positionsCount = data.positionValue ?? gs.positionsCount;
              gs.startDate = data.startDate ? moment(data.startDate).format('YYYY-MM-DD') : (data.StartDate ? moment(data.StartDate).format('YYYY-MM-DD') : "");
              gs.endDate = data.endDate ? moment(data.endDate).format('YYYY-MM-DD') : (data.EndDate ? moment(data.EndDate).format('YYYY-MM-DD') : "");
              gs.startTime = data.startTime ?? gs.startTime;
              gs.endTime = data.endTime ?? gs.endTime;
              gs.instructionDescription = data.instructionDescription ?? gs.instructionDescription;
              gs.importantNotes = data.importantNotes ?? gs.importantNotes;
              gs.agmUrl = data.agmurl ?? gs.agmUrl;
              // store BasicSettingId for edits
              gs.basicSettingId = data.basicSettingId ?? data.BasicSettingId ?? null;
              this.setState({ generalSettings: gs });
            }
          } else {
            // optionally show error if needed
            if (response && response.message) this.swalServices.Error(response.message);
          }
        });
    }
  }

  saveGeneralSettings = () => {
    const detail = this.state.generalSettings;
    const request = {
      BasicSettingId: detail.basicSettingId ?? 0,
      PositionValue: detail.positionsCount ? Number(detail.positionsCount) : null,
      StartDate: detail.startDate ? detail.startDate : null,
      EndDate: detail.endDate ? detail.endDate : null,
      StartTime: detail.startTime ?? null,
      EndTime: detail.endTime ?? null,
      InstructionDescription: detail.instructionDescription ?? null,
      ImportantNotes: detail.importantNotes ?? null,
      AGMURL: detail.agmUrl ?? null,
      AdminId: this.state.adminUserId > 0 ? this.state.adminUserId : null,
    };

    this.eVotingServices.addEditeVotingBasicSetting(request).then((response) => {
      if (response && response.statusCode === 200 && response.responseItem != null) {
        this.swalServices.Success('General settings updated successfully.');
        // update basicSettingId if returned by server
        const respContent = response.responseItem.responseContent;
        if (respContent && respContent > 0) {
          let gs = { ...this.state.generalSettings };
          gs.basicSettingId = respContent;
          this.setState({ generalSettings: gs });
        }
      } else {
        this.swalServices.Error(response ? response.message : 'Failed to update basic settings.');
      }
    })
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.isValidateAllFields()) {
      // Call API to save settings
      this.saveGeneralSettings();
    } else {
      this.swalServices.Error("Please resolve the validation errors.");
    }
  };

  render() {
    const { generalSettings, validState, positionsOptions } = this.state;

    return (
      <div className="main-body-section">
        <div className="bg-white rounded-sm shadow-md">
          <div className="heading-part px-7 py-4 border-b flex items-center justify-between">
            <h4 className="small-title font-bold theme-color text-2xl">
              General
            </h4>
          </div>
          <div className="px-7 py-4 pt-10">
            <div>
              <div className="mb-8 border border-gray-200 p-6 rounded bg-gray-50/50">
                <h5 className="text-xl font-bold mb-6 theme-color border-b pb-2">Basic Setting</h5>

                <div className="grid grid-cols-12 gap-6">
                  {/* Positions Dropdown */}
                  <div className="col-span-12 md:col-span-6 mb-4">
                    <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                      How many positions for selection this year? <span className="text-[#C00000]">*</span>
                    </label>
                    <DropdownSelect
                      optionArray={positionsOptions}
                      value={generalSettings.positionsCount}
                      drpIdentity="positionsCount"
                      setFilterParameters={this.handleDropdownChange}
                      isRemoveDefaultOption={true}
                    />
                    <ValidationText error={validState.error.positionsCount} />
                  </div>

                  <div className="col-span-12"></div>

                  {/* Start Date & Time */}
                  <div className="col-span-12 md:col-span-3 mb-4">
                    <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                      Start Date <span className="text-[#C00000]">*</span>
                    </label>
                    <DatePicker
                      name="startDate"
                      value={generalSettings.startDate}
                      handleChange={this.handleChange}
                    />
                    <ValidationText error={validState.error.startDate} />
                  </div>

                  <div className="col-span-12 md:col-span-2 mb-4 xl:col-span-2 lg:col-span-2">
                    <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                      Start Time <span className="text-[#C00000]">*</span>
                    </label>
                    <TimePicker
                      identity="startTime"
                      value={generalSettings.startTime}
                      setTime={this.handleTimeChange}
                    />
                    <ValidationText error={validState.error.startTime} />
                  </div>

                  {/* "to" spacer */}
                  <div className="col-span-12 md:col-span-1 flex items-center justify-center font-bold text-gray-500 mb-4 pt-8">
                    to
                  </div>

                  {/* End Date & Time */}
                  <div className="col-span-12 md:col-span-3 mb-4 xl:col-span-3 lg:col-span-3">
                    <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                      End Date <span className="text-[#C00000]">*</span>
                    </label>
                    <DatePicker
                      name="endDate"
                      value={generalSettings.endDate}
                      handleChange={this.handleChange}
                      minDate={generalSettings.startDate}
                    />
                    <ValidationText error={validState.error.endDate} />
                  </div>

                  <div className="col-span-12 md:col-span-3 mb-4 xl:col-span-3 lg:col-span-3">
                    <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                      End Time <span className="text-[#C00000]">*</span>
                    </label>
                    <TimePicker
                      identity="endTime"
                      value={generalSettings.endTime}
                      setTime={this.handleTimeChange}
                    />
                    <ValidationText error={validState.error.endTime} />
                  </div>
                </div>

                <div className="grid grid-cols-12 gap-6 mt-6">
                  {/* Instruction Description */}
                  <div className="col-span-12 mb-6">
                    <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                      Instruction Description <span className="text-[#C00000]">*</span>
                    </label>
                    <div className="ck-editor-sec ck-editor-sec-for-page-managment">
                      <CKClassicEditor
                        key="instructionDescription"
                        data={generalSettings.instructionDescription}
                        onChange={(event, editor) => this.handleEditorChange(editor.getData(), "instructionDescription")}
                      />
                    </div>
                    <ValidationText error={validState.error.instructionDescription} />
                  </div>

                  {/* Important Notes */}
                  <div className="col-span-12 mb-6">
                    <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                      Important Notes
                    </label>
                    <div className="ck-editor-sec border ck-editor-sec-for-page-managment">
                      <CKClassicEditor
                        key="importantNotes"
                        data={generalSettings.importantNotes}
                        onChange={(event, editor) => this.handleEditorChange(editor.getData(), "importantNotes")}
                      />
                    </div>
                  </div>

                  {/* AGM URL */}
                  <div className="col-span-12 mb-4">
                    <label className="filter-lable block font-medium mb-3 theme-color min-h-30">
                      AGM URL <span className="text-[#C00000]">*</span>
                    </label>
                    <InputText
                      name="agmUrl"
                      value={generalSettings.agmUrl}
                      handleChange={this.handleChange}
                      validateField={this.validateField}
                    />
                    <ValidationText error={validState.error.agmUrl} />
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="flex justify-end pt-4 border-t gap-4">
                <button
                  type="button"
                  onClick={this.handleSubmit}
                  className="btn btn-red text-white py-3 px-8 text-lg font-semibold rounded-none tracking-normal"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
